.gy{z-index:2;}